import { schema } from "normalizr";
export const accountPlanLimit = new schema.Entity("accountPlanLimit");
export const accountPlanLimitSchema = new schema.Entity("accountPlanLimits", {
  accountPlanLimits: [accountPlanLimit]
}, {
  idAttribute: "feature"
});